// testing midleware 
// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'a2772753-62a0-448d-9f75-8f7bf52aa196',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'adabe730-9abc-478a-ae9d-b8ee48c96945',
      type: 'Sprite',
      name: 'tapIndicator',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Point_Bubble',
      parent: 'a2772753-62a0-448d-9f75-8f7bf52aa196'
    },
    {
      id: '8394f14a-255f-44fe-ac3c-8d23c3fa2ecb',
      type: 'Sprite',
      name: 'hand',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tutorial_hand',
      parent: 'a2772753-62a0-448d-9f75-8f7bf52aa196'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '85985fa4-af55-4f01-93f5-9450ace7fed4',
      name: 'Tap',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '5af7555e-7fd4-4f88-b2dd-fe8c2076d0d0',
          type: 'Setter',
          name: 'indicatorSetter',
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            },
            alpha: 1
          },
          startAt: 0,
          sourceName: 'tapIndicator',
          disabled: false
        },
        {
          id: '5ea7d8d6-745a-4c8f-8f43-2a217a227a8d',
          type: 'Setter',
          name: 'handSetter',
          track: 1,
          target: {
            x: 57,
            y: -90
          },
          startAt: 0,
          sourceName: 'hand',
          disabled: false
        },
        {
          id: '184519d0-f4d9-4fd5-92ad-1b2594833a73',
          type: 'Tween',
          name: 'handTap',
          duration: 400,
          track: 4,
          target: {
            x: 0,
            y: 0,
            angle: -17
          },
          startAt: 111,
          sourceName: 'hand',
          easing: 'CubicIn',
          disabled: false
        },
        {
          id: 'f92d9807-a874-428b-b216-ca72087e7149',
          type: 'Tween',
          name: 'indicatorScaleUp',
          duration: 300,
          track: 4,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 0
          },
          startAt: 511,
          sourceName: 'tapIndicator',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '099edcba-acb4-4a34-85bb-1825f7393666',
          type: 'Tween',
          name: 'handMoveOut',
          duration: 400,
          track: 5,
          target: {
            x: 57,
            y: -90,
            angle: 0
          },
          startAt: 516,
          sourceName: 'hand',
          easing: 'CubicInOut',
          disabled: false
        }
      ]
    },
    {
      id: '137e9542-a47d-4859-bef6-1a063195a57b',
      name: 'DragStart',
      playingSpeed: 1,
      totalDuration: 600,
      blocks: [
        {
          id: '887b4d25-82b8-4b56-951f-16e9ed061ed4',
          type: 'Setter',
          name: 'handSetter_copy',
          track: 1,
          target: {
            x: 57,
            y: -90
          },
          startAt: 0,
          sourceName: 'hand',
          disabled: false
        },
        {
          id: '35184de7-3542-43ef-8148-4cc828b3057c',
          type: 'Setter',
          name: 'indicatorSetter',
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            },
            alpha: 0
          },
          startAt: 0,
          sourceName: 'tapIndicator',
          disabled: false
        },
        {
          id: 'eb2cdce3-3efc-4465-8ca4-2fb8b793f276',
          type: 'Tween',
          name: 'handTap_copy',
          duration: 400,
          track: 3,
          target: {
            x: 0,
            y: 0,
            angle: -17
          },
          startAt: 111,
          sourceName: 'hand',
          easing: 'CubicIn',
          disabled: false
        },
        {
          id: 'd3cdae56-1ddb-4e17-9ecd-7fb7c1d4c768',
          type: 'Tween',
          name: 'indicatorFadeIn',
          duration: 150,
          track: 4,
          target: {
            scale: {},
            alpha: 1
          },
          startAt: 451,
          sourceName: 'tapIndicator',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: '18f986c8-2d14-487c-b7eb-97ebdc245389',
      name: 'DragEnd',
      playingSpeed: 1,
      totalDuration: 500,
      blocks: [
        {
          id: '322dfe3c-863d-4ae0-9a63-e3614526fe68',
          type: 'Tween',
          name: 'handMoveOut_copy',
          duration: 400,
          track: 1,
          target: {
            x: 57,
            y: -90,
            angle: 0
          },
          startAt: 0,
          sourceName: 'hand',
          easing: 'CubicInOut',
          disabled: false
        },
        {
          id: 'a5de644f-15df-42af-8730-48785187bfe2',
          type: 'Tween',
          name: 'indicatorFadeOut',
          duration: 200,
          track: 3,
          target: {
            scale: {
              x: 1.5,
              y: 1.5
            },
            alpha: 0
          },
          startAt: 0,
          sourceName: 'tapIndicator',
          easing: 'Linear',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class TutorialHandLayout {
  static raw = raw;
  root!: Container;
  tapIndicator!: Sprite;
  hand!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Tap {
  Layout: {
    tapIndicator: object;
    hand: object;
  };

  BlockTypeByName: {
    indicatorSetter: object;
    handSetter: object;
    handTap: object;
    indicatorScaleUp: object;
    handMoveOut: object;
  };

  flowData = raw.animations[0];
}

export abstract class DragStart {
  Layout: {
    hand: object;
    tapIndicator: object;
  };

  BlockTypeByName: {
    handSetter_copy: object;
    indicatorSetter: object;
    handTap_copy: object;
    indicatorFadeIn: object;
  };

  flowData = raw.animations[1];
}

export abstract class DragEnd {
  Layout: {
    hand: object;
    tapIndicator: object;
  };

  BlockTypeByName: {
    handMoveOut_copy: object;
    indicatorFadeOut: object;
  };

  flowData = raw.animations[2];
}
